import { render, staticRenderFns } from "./shortcuts_toggle.vue?vue&type=template&id=2dadbe35&"
import script from "./shortcuts_toggle.vue?vue&type=script&lang=js&"
export * from "./shortcuts_toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports